import { useEffect } from "react";
import { BodyScriptConfig } from "src/constants/omotiScripts";
import { appendBodyScript } from "src/utils/appendBodyScript";

interface UseBodyScriptOptions extends BodyScriptConfig {
  /** false の場合はスクリプトを挿入しない（条件付き挿入に使用） */
  enabled?: boolean;
}

/**
 * <body> 終了タグ直前（document.body の末尾）に <script> 要素を挿入し、
 * アンマウント時に除去するフック。
 *
 * SPA で特定画面だけにサードパーティタグを埋め込むために使用する。
 */
export const useBodyScript = ({
  src,
  attributes,
  enabled = true,
}: UseBodyScriptOptions): void => {
  // attributes はオブジェクト参照が毎レンダー変わり得るため、
  // 依存配列では中身を文字列化して比較する。
  const serializedAttributes = JSON.stringify(attributes);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const script = appendBodyScript({ src, attributes });

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, serializedAttributes, enabled]);
};
